"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_PERMISSION = void 0;
var ACTION_PERMISSION;
(function (ACTION_PERMISSION) {
    ACTION_PERMISSION[ACTION_PERMISSION["READ"] = 1] = "READ";
    ACTION_PERMISSION[ACTION_PERMISSION["WRITE"] = 2] = "WRITE";
    ACTION_PERMISSION[ACTION_PERMISSION["READ_WRITE"] = 3] = "READ_WRITE";
    ACTION_PERMISSION[ACTION_PERMISSION["EDIT"] = 4] = "EDIT";
    ACTION_PERMISSION[ACTION_PERMISSION["DELETE"] = 5] = "DELETE";
})(ACTION_PERMISSION = exports.ACTION_PERMISSION || (exports.ACTION_PERMISSION = {}));
